import { localizationSelectors, authSelectors } from '@lifesize/nucleus';
import { NAVIGATE_TO_TRIAL_PAGE } from 'constants/Application';
import { getAdminConsoleUrl } from 'utils/UrlUtil';

export function navigateToTrialPage() {
  return (dispatch, getState) => {
    const localization = localizationSelectors.localization(getState());
    const locale = (localization.language === 'zh') ? localization.languageId : localization.language;
    const trialURL = `https://www.lifesize.com/${locale}/ldp/guest-call`;
    return dispatch({
      type: NAVIGATE_TO_TRIAL_PAGE,
      payload: trialURL
    });
  };
}

export function openAdminConsole() {
  return (dispatch, getState) => {
    const state = getState();
    const jwt = authSelectors.getPrimaryJwt(state);
    const url = new URL(getAdminConsoleUrl());
    if (jwt) {
      url.searchParams.append('a', jwt);
    }
    window.open(url.href);
  };
}

export default {
  navigateToTrialPage
};
